(function () {
  'use strict';

  angular
      .module('tfc.retailer.ConsumerSampling')
      .factory('ConsumerSamplingReport', ConsumerSamplingReport);

  // @ngInject
  function ConsumerSamplingReport($q, util, Upload, ExcelReportType, GaUtil, Api, BRAND_URL){

    return {
      downloadReport : downloadReport
    };

    function generateURL(brandKey) {
      var BASE_URL = BRAND_URL + encodeURIComponent(brandKey) + '/consumer/sampling/report';
      return BASE_URL;
    }

    function content(selectedBrandKey) {
      return Api.get(generateURL(selectedBrandKey), {
        cache : false,
        responseType : 'arraybuffer',
        headers: {
          'Accept': ExcelReportType
        }
      }).then(function (response) {
        var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
        return $q.all({
          fileName: disposition.filename,
          dataBlob: new Blob([response.data], { type : disposition['content-type'] })
        });
      });
    }

    function downloadReport(selectedBrandKey) {
      return $q.when(content(selectedBrandKey)).then(function (content) {
        download(content.dataBlob, content.fileName, ExcelReportType);
        GaUtil.sendGaEvent(selectedBrandKey, 'Download Report', 'Consumer Sampling Report');
      });
    }
  }

})();
